import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholder by Sentiment',
      type: 'charts',
      alias: 'stakeholders-by-sentiment',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Sentiment',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Stakeholders',
                          color: '#2F5DA8',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Positive',
                                  y: {
                                    '#': {
                                      '@': 'positiveStakeholders',
                                    },
                                  },
                                  name: 'Positive',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      perceivedAttitude:
                                                        'Positive',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Negative',
                                  y: {
                                    '#': {
                                      '@': 'negativeStakeholders',
                                    },
                                  },
                                  name: 'Negative',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      perceivedAttitude:
                                                        'Negative',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Neutral',
                                  y: {
                                    '#': {
                                      '@': 'neutralStakeholders',
                                    },
                                  },
                                  name: 'Neutral',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      perceivedAttitude:
                                                        'Neutral',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Unknown',
                                  y: {
                                    '#': {
                                      '@': 'unknownStakeholders',
                                    },
                                  },
                                  name: 'Unknown',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      perceivedAttitude:
                                                        'Unknown',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Sentiment',
                  yLabel: 'Stakeholders',
                  description:
                    'Stakeholder count by perceived attitude. Unknown includes unassessed stakeholders.',
                },
              },
            ],
          },
          type: 'bar',
          config: {
            '{}': {
              yAxis: {
                '{}': {
                  min: 0,
                  tickInterval: 1,
                  allowDecimals: false,
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    neutralStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!perceived_attitude',
          },
          'Neutral',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    unknownStakeholders: {
      filter: {
        or: [
          {
            '=': [
              {
                '@.': '!perceived_attitude',
              },
              'Unknown',
            ],
          },
          {
            '=': [
              {
                '@.': '!perceived_attitude',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@.': '!perceived_attitude',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    negativeStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!perceived_attitude',
          },
          'Negative',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    positiveStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!perceived_attitude',
          },
          'Positive',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
  },
}
